'use client';

import { SearchTwoTone } from '@mui/icons-material';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { Box, IconButton, TextField, Tooltip, type SxProps } from '@mui/material';
import { flatSx, FlexColumn, FlexRow } from '@ocodelib/mui';
import { useObservable } from '@ocodelib/mui/hooks';
import { Console as ConsoleFeed } from 'console-feed';
import { useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useJsBasicApp } from '../../useJsBasicApp';

interface Props {
  sx?: SxProps;
}

export function LogContainer(props: Props) {
  const { sx } = props;
  const { app } = useJsBasicApp();
  const [logSearchKeyword, setLogSearchKeyword] = useState('');
  const logs = useObservable(app?.logs$) ?? [];

  return (
    <FlexColumn
      className="LogContainer-root"
      sx={flatSx(
        {
          position: 'relative',
          bgcolor: '#fff',
          overflow: 'hidden',
          width: '100%',
        },
        sx,
      )}
    >
      <FlexRow
        alignItems="center"
        sx={{
          height: 40,
          px: 1,
          bgcolor: '#edeff1',
          borderBottom: '1px solid #ddd',
          width: '100%',
        }}
      >
        <SearchTwoTone
          sx={{
            color: '#aaa',
            fontSize: '1.2rem',
          }}
        />
        <TextField
          margin="none"
          value={logSearchKeyword ?? ''}
          size="small"
          placeholder="Log filter"
          autoComplete="off"
          sx={{
            width: '100vw',
            maxWidth: 300,
            ml: 1,
            '& input': {
              py: '5px',
            },
          }}
          onChange={(e) => {
            setLogSearchKeyword(e.target.value);
          }}
        />
        <Tooltip title="clear log">
          <span>
            <IconButton
              size="small"
              color="primary"
              disabled={!app}
              onClick={() => {
                app?.clearLogs();
              }}
              sx={{ ml: 'auto', color: '#888' }}
            >
              <CleaningServicesIcon />
            </IconButton>
          </span>
        </Tooltip>
      </FlexRow>
      <Scrollbars style={{ flex: 1 }}>
        <Box
          component={ConsoleFeed}
          variant="light"
          logs={logs ?? []}
          styles={{
            BASE_FONT_SIZE: '16px',
          }}
          searchKeywords={logSearchKeyword}
        />
      </Scrollbars>
    </FlexColumn>
  );
}
